/**
 * Paletas predefinidas para Admin → Sitio y contacto → Tema y colores.
 * Cada preset define los 5 hex guardados en clinic_info.
 */
export const THEME_PRESETS = [
  {
    id: 'pizza-red',
    name: 'Pizzería roja (clásico)',
    theme_primary_hex: '#C62828',
    theme_background_hex: '#FFF5F5',
    theme_foreground_hex: '#2D0A0A',
    theme_accent_hex: '#FF6B6B',
    theme_muted_hex: '#FFD4D4',
    theme_show_checkerboard: true,
  },
  {
    id: 'orange-fire',
    name: 'Naranja fuego',
    theme_primary_hex: '#E65100',
    theme_background_hex: '#FFF8F0',
    theme_foreground_hex: '#3E1F00',
    theme_accent_hex: '#FF9800',
    theme_muted_hex: '#FFE0B2',
    theme_show_checkerboard: true,
  },
  {
    id: 'orange-sunset',
    name: 'Naranja atardecer',
    theme_primary_hex: '#F4511E',
    theme_background_hex: '#FFF3E8',
    theme_foreground_hex: '#4A1C0A',
    theme_accent_hex: '#FF7043',
    theme_muted_hex: '#FFCCBC',
    theme_show_checkerboard: false,
  },
  {
    id: 'red-bold',
    name: 'Rojo intenso',
    theme_primary_hex: '#B71C1C',
    theme_background_hex: '#FFEBEE',
    theme_foreground_hex: '#1A0505',
    theme_accent_hex: '#EF5350',
    theme_muted_hex: '#FFCDD2',
    theme_show_checkerboard: true,
  },
  {
    id: 'blue-navy',
    name: 'Azul marino',
    theme_primary_hex: '#0D47A1',
    theme_background_hex: '#E3F2FD',
    theme_foreground_hex: '#0A1A33',
    theme_accent_hex: '#42A5F5',
    theme_muted_hex: '#BBDEFB',
    theme_show_checkerboard: false,
  },
  {
    id: 'blue-sky',
    name: 'Azul cielo',
    theme_primary_hex: '#0277BD',
    theme_background_hex: '#F0F9FF',
    theme_foreground_hex: '#0C2D48',
    theme_accent_hex: '#29B6F6',
    theme_muted_hex: '#B3E5FC',
    theme_show_checkerboard: false,
  },
  {
    id: 'blue-royal',
    name: 'Azul real',
    theme_primary_hex: '#1565C0',
    theme_background_hex: '#E8EAF6',
    theme_foreground_hex: '#0D1B3D',
    theme_accent_hex: '#5C6BC0',
    theme_muted_hex: '#C5CAE9',
    theme_show_checkerboard: false,
  },
  {
    id: 'green-lime',
    name: 'Verde limón',
    theme_primary_hex: '#558B2F',
    theme_background_hex: '#F1F8E9',
    theme_foreground_hex: '#1B2E0F',
    theme_accent_hex: '#8BC34A',
    theme_muted_hex: '#DCEDC8',
    theme_show_checkerboard: false,
  },
  {
    id: 'green-forest',
    name: 'Verde bosque',
    theme_primary_hex: '#2E7D32',
    theme_background_hex: '#E8F5E9',
    theme_foreground_hex: '#0D1F0E',
    theme_accent_hex: '#66BB6A',
    theme_muted_hex: '#C8E6C9',
    theme_show_checkerboard: false,
  },
  {
    id: 'yellow-sun',
    name: 'Amarillo sol',
    theme_primary_hex: '#F9A825',
    theme_background_hex: '#FFFDE7',
    theme_foreground_hex: '#3E2723',
    theme_accent_hex: '#FFCA28',
    theme_muted_hex: '#FFF9C4',
    theme_show_checkerboard: true,
  },
  {
    id: 'yellow-mustard',
    name: 'Amarillo mostaza',
    theme_primary_hex: '#F57F17',
    theme_background_hex: '#FFF8E1',
    theme_foreground_hex: '#3E2723',
    theme_accent_hex: '#FFB300',
    theme_muted_hex: '#FFECB3',
    theme_show_checkerboard: false,
  },
  {
    id: 'teal-fresh',
    name: 'Turquesa fresco',
    theme_primary_hex: '#00897B',
    theme_background_hex: '#E0F2F1',
    theme_foreground_hex: '#0A2E2A',
    theme_accent_hex: '#26A69A',
    theme_muted_hex: '#B2DFDB',
    theme_show_checkerboard: false,
  },
];

const norm = (hex) => String(hex || '').trim().toLowerCase();

export function findMatchingThemePreset(draft) {
  if (!draft) return 'custom';
  const match = THEME_PRESETS.find(
    (p) =>
      norm(p.theme_primary_hex) === norm(draft.theme_primary_hex) &&
      norm(p.theme_background_hex) === norm(draft.theme_background_hex) &&
      norm(p.theme_foreground_hex) === norm(draft.theme_foreground_hex) &&
      norm(p.theme_accent_hex) === norm(draft.theme_accent_hex) &&
      norm(p.theme_muted_hex) === norm(draft.theme_muted_hex)
  );
  return match?.id || 'custom';
}

export function themePresetToFields(preset) {
  if (!preset) return {};
  return {
    theme_primary_hex: preset.theme_primary_hex,
    theme_background_hex: preset.theme_background_hex,
    theme_foreground_hex: preset.theme_foreground_hex,
    theme_accent_hex: preset.theme_accent_hex,
    theme_muted_hex: preset.theme_muted_hex,
    theme_show_checkerboard: Boolean(preset.theme_show_checkerboard),
  };
}
